<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Drawer</h1>
  </div>
</div>

<ui-platform-drawer
  [cancelLabel]="'Cancel'"
  [confirmLabel]="'Confirm'"
  [inProgress]="inProgress"
  [visible]="visible"
  (closeDrawer)="closeDrawer()"
  (confirmDrawer)="closeDrawer()">
  <p>Content</p>
  <h3>In progress</h3>
  <p>Makes the confirm button in progress - disabled with spinner</p>
  <div class="button-row">
    <ui-platform-button
      label="Toggle in progress"
      [type]="'secondary'"
      (click)="toggleInProgress()">
    </ui-platform-button>

    <div class="mb-0">
      <b>In progress:</b>
      <pre class="mb-0">{{ inProgress }}</pre>
    </div>
  </div>
</ui-platform-drawer>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Options</h2>
    <h3>Visible</h3>
    <p>Enables the drawer - visibility</p>
    <div class="button-row">
      <ui-platform-button
        label="Make visible"
        [type]="'primary'"
        (click)="makeVisible()">
      </ui-platform-button>
    </div>
    <h3>In progress</h3>
    <p>Makes the confirm button in progress - disabled with spinner</p>
    <div class="button-row">
      <ui-platform-button
        label="Toggle in progress"
        [type]="'secondary'"
        (click)="toggleInProgress()">
      </ui-platform-button>

      <div class="mb-0">
        <b>In progress:</b>
        <pre class="mb-0">{{ inProgress }}</pre>
      </div>
    </div>
    <h3>Labels</h3>
    <p>Confirm <code>confirmLabel</code> and Cancel <code>cancelLabel</code> label texts</p>
    <h3>Callbacks</h3>
    <p>Confirm <code>confirmDrawer</code>and Cancel <code>closeDrawer</code> callbacks</p>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Template usage</h2>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <h2>Code</h2>
    <p>Declare module:</p>
    <pre>{{ import }}</pre>
    <p>Use component in a template:</p>
    <pre>{{ usage }}</pre>
  </div>
</div>
